import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IPipelineMast } from "../../models/PipelineMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { ISubmissionStatusDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

const schema = yup.object({
    req_ID: yup.number().required().positive(),
    consultant_ID: yup.number().required().positive(),
    submission_ID: yup.number().required().positive(),
    status_Name: yup.string().required(),
    comment: yup.string().when('status_Name', val => {
        return (val === "Rejected by Sales Manager" || val === "Rejected by PV" || val === "Rejected by End Client") ?
            yup.string().required("comment is required") :
            yup.string().nullable()
    }),
    rejectedByPVReasonStatus: yup.string().when('status_Name', val => {
        return (val === "Rejected by PV" || val === "Rejected by End Client") ?
            yup.string().required("status is required") :
            yup.string().nullable()
    }),
});

interface Iprops {
    singleData: IPipelineMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    ShowCelebration: (type: string) => void
}

export const Form = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState<Array<ISubmissionStatusDropdown>>([]);
    const [submissionStatusDrop, setSubmissionStatusDrop] = useState<Array<ISubmissionStatusDropdown>>([]);
    const [showRejectiedByPVReasonStatus, setShowRejectiedByPVReasonStatus] = useState<boolean>(false);
    const [rejectedByPVReasondDropDownRows, setRejectedByPVReasondDropDownRows] = useState([]);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IPipelineMast & { rejectedByPVReasonStatus?: number }>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const loadSubmissionStatus = async () => {
        const response = await Fetch("Dropdown/submissionStatus", "GET", null, null, null);
        if (response) {
            const data: Array<ISubmissionStatusDropdown> = await response.json();
            // console.log(data);
            const _data: Array<ISubmissionStatusDropdown> = [];
            data.forEach(item => {
                if (item.status_ID === 2 || item.status_ID === 3 || item.status_ID === 4 || item.status_ID === 6 || item.status_ID === 12 || item.status_ID === 24 || item.status_ID === 27 || item.status_ID === 29) {
                    _data.push(item);
                }
            });
            setSubmissionStatus(_data);
        }
    }

    useEffect(() => {
        loadSubmissionStatus();
    }, []);

    useEffect(() => {
        reset(props.singleData);
        const _submissionStatus = [...submissionStatus];

        if (props.singleData.status_Name === "Submitted by Recruiter") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : _submissionStatus.filter(item => (item.status_Name === "Accepted by Sales Manager" || item.status_Name === "Rejected by Sales Manager" || item.status_Name === "Requirement Hold by PV"));
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "Accepted by Sales Manager") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : _submissionStatus.filter(item => (item.status_Name === "Submitted to End Client" || item.status_Name === "Rejected by PV" || item.status_Name === "Requirement Hold by PV" || item.status_Name === "PV Not Responding"));
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "Submitted to End Client") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : (props.singleData.absM_Req_ID !== null && (props.singleData.absM_Req_ID || 0) >= 2 ? _submissionStatus.filter(item => (item.status_Name === "Rejected by End Client" || item.status_Name === "Requirement Hold by PV" || item.status_Name === "No Additional room for ECS" || item.status_Name === "PV Not Responding")) : _submissionStatus.filter(item => (item.status_Name === "Rejected by End Client" || item.status_Name === "Requirement Hold by PV" || item.status_Name === "PV Not Responding")));
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "Rejected by PV" || props.singleData.status_Name === "Rejected by End Client") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : _submissionStatus.filter(item => (item.status_Name === "Submitted to End Client" || item.status_Name === "Requirement Hold by PV"));
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "Rejected by Sales Manager") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : _submissionStatus.filter(item => (item.status_Name === "Accepted by Sales Manager" || item.status_Name === "Requirement Hold by PV"));
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "Requirement Hold by PV") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : [];
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "No Additional room for ECS") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : [];
            setSubmissionStatusDrop(tempDrop);
        } else if (props.singleData.status_Name === "PV Not Responding") {
            const tempDrop = _roles.includes(1) ? _submissionStatus : [];
            setSubmissionStatusDrop(tempDrop);
        } else {
            setSubmissionStatusDrop([]);
        }
    }, [props.singleData, submissionStatus]);

    const saveToDB = async (body: IPipelineMast) => {
        setLoading(true);
        const response = await Fetch("Pipeline_Mast", "PUT", body, null, props.toast);
        if (response) {
            const data = await response.json();
            if (data.salesTargetCompleted === true) {
                props.ShowCelebration(data.type);
            }
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            setShowRejectiedByPVReasonStatus(s => s = false);
            setRejectedByPVReasondDropDownRows([]);
            props.hideDialog();
            props.setReload(!props.reload);
            setLoading(false);
        } else setLoading(false);
    }

    const onHide = () => {
        setShowRejectiedByPVReasonStatus(s => s = false);
        props.hideDialog();
    }

    function onSubmit(data: IPipelineMast) {
        saveToDB(data);
    }

    const subDate = (rowData: IPipelineMast) => {
        let date;
        if (rowData.subDate) date = format(new Date(rowData.subDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    // const RejectedByPVReasondDropDownRows = [
    //     { name: '-- SELECT --', value: 0 },
    //     { name: 'Testing 1', value: 1 },
    //     { name: 'Testing 2', value: 2 },
    //     { name: 'Testing 3', value: 3 },
    //     { name: 'Testing 4', value: 4 },
    //     { name: 'Testing 5', value: 5 },
    // ];

    async function LoadSubRejectionCategory(name: string) {
        const response = await Fetch("Pipeline_Status_Mast/getSubCategoryListing", "GET", null, `ssn=${name}`, props.toast);
        if (response) {
            const data = await response.json();
            setRejectedByPVReasondDropDownRows(data);
        }
    }

    useEffect(() => {

        const subscription = watch((value, { name, type }) => {
            if (name === "status_Name") {
                if (value.status_Name === "Rejected by PV" && value.status_Name != null) {
                    setShowRejectiedByPVReasonStatus(s => s = true);
                    LoadSubRejectionCategory("Rejected by PV");
                } else if (value.status_Name === "Rejected by End Client" && value.status_Name != null) {
                    setShowRejectiedByPVReasonStatus(s => s = true);
                    LoadSubRejectionCategory("Rejected by End Client");
                } else setShowRejectiedByPVReasonStatus(s => s = false);
            }
            // if (name === "req_Term") {
            //     if (value.req_Term === ""Rejected by End Client"") setFormValues((val) => { return { ...val, isJTermP: true } });
            //     else setFormValues((val) => { return { ...val, isJTermP: false } });
            // } else if (name === "job_Type") {
            //     if (value.job_Type === "Remote") setFormValues((val) => { return { ...val, isJTypeR: true } });
            //     else setFormValues((val) => { return { ...val, isJTypeR: false } })
            // }

            return () => subscription.unsubscribe();
        });

    }, [watch]);

    const DateFormat = loginObj.date_Format
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Update Pipeline" modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={[props.singleData]}
                emptyMessage="No Pipeline found."
            >
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="req_Job_Title" header="Job Title" />
                {/* <Column field="subDate" header="Sub Date" body={subDate} /> */}
                 <Column field="subDate" header="Sub Date" body={(rowData: any) => safeFormatDate(rowData.subDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="recruiter" header="Recruiter" body={(rowData) => { const value = rowData.recruiter; if (!value) return ""; return value.split("-")[0]; }} />
            </DataTable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-4">

                <JVDropdown label="Status" required control={control} name="status_Name" options={submissionStatusDrop} optionLabel="status_Name" optionValue="status_Name" placeholder="Select Status" error={errors.status_Name?.message} />
                {showRejectiedByPVReasonStatus && <JVDropdown label="Reason Status" required={showRejectiedByPVReasonStatus} column={2} control={control} name="rejectedByPVReasonStatus" options={rejectedByPVReasondDropDownRows} optionLabel="sub_Status_Name" optionValue="sub_Status_Name" placeholder="Select Rejection Reason" error={errors.rejectedByPVReasonStatus?.message} />}
                <JVInput label="Comment" control={control} name="comment" placeholder="Comment" error={errors.comment?.message} />

                {/* <div className="col-12 md:col-12">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px' }}>
                        <Button loading={loading} className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div> </div> */}
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
